export const UTILITY_USER_SESSION_PROVIDER_PASSWORD = 'password';
export const UTILITY_USER_SESSION_PROVIDER_VERIFICATION_CODE = 'verificationCode';

export const UTILITY_USER_STATUS_PENDING_SIGNUP = 'PendingSignup';
export const UTILITY_USER_STATUS_ACTIVE = 'Active';

export const UTILITY_USER_ROLE_ANONYMOUS = 'anonymous';
export const UTILITY_USER_ROLE_RENTER = 'renter';
export const UTILITY_USER_ROLE_ADMIN = 'admin';
export const UTILITY_USER_ROLE_PARTNER = 'partner';
export const UTILITY_USER_ROLE_PRESERVE_ON_DEV = 'preserveOnDev';
export const UTILITY_USER_ROLE_SALES_REP = 'salesRep';
export const UTILITY_USER_ROLE_SALES_REP_MANAGER = 'salesRepManager';
export const UTILITY_USER_ROLE_ACCOUNT_MANAGER = 'accountManager';
export const UTILITY_USER_ROLE_GROUP_ADMIN = 'groupAdmin';
export const UTILITY_USER_ROLE_PARTNER_ADMIN = 'partnerAdmin';
export const UTILITY_USER_ROLE_PARTNER_ACCOUNTING = 'partnerAccounting';
export const UTILITY_USER_ROLE_PARTNER_PROPERTY_MANAGER = 'partnerPropertyManager';
export const UTILITY_USER_ROLE_VIEW_REVENUE = 'viewRevenue';

export const ALL_USER_ROLES = [
  UTILITY_USER_ROLE_ANONYMOUS,
  UTILITY_USER_ROLE_RENTER,
  UTILITY_USER_ROLE_ADMIN,
  UTILITY_USER_ROLE_PARTNER,
  UTILITY_USER_ROLE_SALES_REP,
  UTILITY_USER_ROLE_SALES_REP_MANAGER,
  UTILITY_USER_ROLE_GROUP_ADMIN,
  UTILITY_USER_ROLE_PARTNER_ADMIN,
  UTILITY_USER_ROLE_PARTNER_ACCOUNTING,
  UTILITY_USER_ROLE_PARTNER_PROPERTY_MANAGER,
  UTILITY_USER_ROLE_VIEW_REVENUE,
];

export const SR_STAFF_USER_ROLES = [
  UTILITY_USER_ROLE_ADMIN,
  UTILITY_USER_ROLE_SALES_REP,
  UTILITY_USER_ROLE_SALES_REP_MANAGER,
];

export const hasRoleAnonymous = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_ANONYMOUS);
};

export const hasRoleRenter = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_RENTER);
};

export const hasRoleAdmin = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_ADMIN);
};

export const hasRolePartner = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_PARTNER);
};

export const hasRoleSalesRep = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_SALES_REP);
};

export const hasRoleSalesRepManager = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_SALES_REP_MANAGER);
};

export const hasRoleAccountManager = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_ACCOUNT_MANAGER);
};

export const hasRoleGroupAdmin = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_GROUP_ADMIN);
};

export const hasRolePartnerAdmin = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_PARTNER_ADMIN);
};

export const hasRolePartnerAccounting = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_PARTNER_ACCOUNTING);
};

export const hasRolePartnerPropertyManager = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_PARTNER_PROPERTY_MANAGER);
};

export const hasRoleViewRevenue = (userRoles) => {
  return userRoles.includes(UTILITY_USER_ROLE_VIEW_REVENUE);
};
